import React, { Suspense } from 'react'
import { Link } from 'react-router-dom'

const ServiceCard = ({ icon, title, description }) => {
  return (
    <div
      data-aos="zoom-in"
      data-aos-delay="200"
      data-aos-duration="500"
      className="flex flex-col items-center text-center p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow"
    >
      <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#d4ebff] text-[#1865a5] mb-4">
        {icon}
      </div>
      <h3 className="text-xl font-semibold mb-3">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  )
}

const Services = () => {
  const services = [
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-8 h-8"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"
          />
        </svg>
      ),
      title: 'Employee Transportation Services',
      description:
        'At RoyalRise Tours & Travels, while our brand is newly established, our team brings over 15 years of expertise in delivering safe, cost-effective, and reliable transportation solutions for corporate employees. With a strong focus on quality and efficiency, we are dedicated to ensuring a seamless commute for your workforce.',
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-8 h-8"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      ),
      title: 'Corporate Rentals',
      description:
        'We offer a range of luxury vehicles for corporate clients, professionals, and high-end organizations, all driven by trained chauffeurs. Our services strictly adhere to industry standards to ensure top-notch quality.',
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-8 h-8"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
      ),
      title: 'Corporate Fleet Management',
      description:
        'Our state-of-the-art vehicle management system is managed by an experienced team, offering car rental services tailored for corporate needs. Our luxury fleet is operated by professional drivers who undergo rigorous training.',
    },
  ]

  return (
    <section
      className="py-16 bg-gray-50"
      data-aos="fade-in"
      data-aos-duration="600"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          className="text-center mb-12"
          data-aos="slide-up"
          data-aos-duration="500"
        >
          <h2 className="text-base font-semibold text-[#1865a5] tracking-wide uppercase">
            OUR SERVICES
          </h2>
          <p className="mt-2 text-3xl font-bold text-gray-900 sm:text-4xl">
            What We Offer
          </p>
          <p className="mt-4 text-lg text-gray-500">
            Comprehensive travel solutions tailored to your needs
          </p>
        </div>

        <div
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          data-aos="fade-up"
          data-aos-delay="150"
        >
          <Suspense
            fallback={
              <div className="p-6 bg-white rounded-2xl shadow-sm animate-pulse h-64" />
            }
          >
            {services.map((service, index) => (
              <ServiceCard
                key={index}
                icon={service.icon}
                title={service.title}
                description={service.description}
              />
            ))}
          </Suspense>
        </div>

        <div
          className="flex justify-center mt-8"
          data-aos="slide-up"
          data-aos-delay="300"
          data-aos-duration="500"
        >
          <Link
            to="/service"
            className="bg-transparent hover:bg-[#16476e]  text-[#1865a5] font-semibold hover:text-white py-2 px-4 border border-[#16476e] hover:border-transparent rounded-xl"
          >
            Know More
          </Link>
        </div>
      </div>
    </section>
  )
}

export default Services
